import * as React from "react";
import PropTypes from "prop-types";

import InputAdornment from "@mui/material/InputAdornment";
import { FormTextField } from "./FormTextField";
import { FormColorPicker } from "./FormColorPicker";

export const FormColorField = (props) => {
  const { name, label, buttonProps, popoverProps, endAdornment } = props;

  return (
    <FormTextField
      name={name}
      label={label}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <FormColorPicker
                name={name}
                buttonProps={buttonProps}
                popoverProps={popoverProps}
              />
            </InputAdornment>
          ),
          endAdornment,
        },
        htmlInput: {
          maxLength: "7",
        },
      }}
    />
  );
};

FormColorField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  buttonProps: PropTypes.object,
  popoverProps: PropTypes.object,
  endAdornment: PropTypes.element,
};
